import React from 'react'
import { HoldingOwner } from '../../../models/polymer/HoldingOwner.model'
import { HoldingOccupier } from '../../../models/polymer/HoldingOccupier.model'
import { P2TextDescription } from 'react-bootstrap-common-script'


interface AccordionTitleProps{
  item: HoldingOwner | HoldingOccupier,
  type: "owner" | "occupier";
  isProposed?: boolean,
}
export default function AccordionTitle({type, isProposed = false, ...props}:AccordionTitleProps) {
  const title = type === "owner" ? "New Owner" : "New Occupier";
  return (
    <>
    {!isProposed && <div>
      {props.item && <>
        {(props.item.type === "existing") && <P2TextDescription color="#000" title={props.item?.myinfo?.name} />}
        {(props.item.type === "new") && <P2TextDescription color="#000" title={props.item?.myinfo?.name ? props.item?.myinfo?.name : title} />}
      </>}

    </div>}
    {isProposed && props.item && <P2TextDescription color="#009AAB" title={props.item?.myinfo?.name?.length > 0 ? props.item?.myinfo?.name : title} />}
  </>
  )
}
